// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"bbu_a bhv_i bhv_q bhv_j"};